module.exports = __webpack_public_path__ + "h5/img/mfe_23.7fd0d573.jpg";